import styled from 'styled-components';
import { layout } from 'styles/layout';
import { palette } from 'styles/colors';

export const ProPlanContainer = styled.div`
  position: relative;
  box-shadow: 1px 1px 10px ${palette.fog};
  display: flex;
  padding: 30px;
  justify-content: space-between;
  overflow: hidden;
  max-width: 1200px !important;
  box-sizing: border-box;
  margin: 0 auto;
  width: 310px;

  @media screen and (min-width: ${layout.md}) {
    width: auto;
    margin: 0 100px 75px;
  }

  @media all and (min-width: ${layout.lg}) {
    padding-right: 289px;
    width: auto;
  }

  p {
    font-size: 18px;
    font-weight: 300;
    max-width: 400px;
    margin-bottom: 1em;
  }
`;

export const TopBanner = styled.div`
  position: relative;
  top: -30px;
  left: -30px;
  width: 310px;
  box-sizing: border-box;
  background-color: ${palette.proBlue};
  padding: 12px 54px 6px;
  text-align: center;
  color: ${palette.white};

  @media all and (min-width: ${layout.md}) {
    display: none;
  }

  h2 {
    line-height: 1.4;
  }
`;

export const ProLogo = styled.img`
  width: 90px;
  margin-bottom: 1em;

  @media all and (min-width: ${layout.md}) {
    width: 130px;
  }
`;

export const HighlightImage = styled.img`
  display: none;
  width: 450px;

  @media all and (min-width: ${layout.md}) {
    display: block;
  }
`;

export const MainContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;

  @media all and (min-width: ${layout.md}) {
    text-align: left;

    a {
      align-self: flex-start;
    }
  }
`;

export const MobileHighlightImage = styled.img`
  width: 106%;
  transform: translateX(-12px);

  @media all and (min-width: ${layout.md}) {
    display: none;
  }
`;

export const FloatingRightContainer = styled.div`
  display: none;
  position: absolute;
  width: 196px;
  height: 264px;
  right: -11px;
  top: 58px;
  z-index: 5;
  background: ${palette.proBlue};
  transform: rotate(-99.11deg);
  color: ${palette.white};

  @media all and (min-width: ${layout.lg}) {
    display: block;
  }

  .content {
    position: absolute;
    top: 69px;
    right: 17px;
    transform: rotate(99.11deg);
    text-align: left;

    h3 {
      margin: 0;
      font-family: Walsheim, Helvetica Neue, Helvetica, Arial, sans-serif;
    }

    ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
    }
  }

  .white-shape {
    position: absolute;
    bottom: -1px;
    left: -1px;
    background: transparent;
    width: 0;
    height: 0;
    border-color: transparent transparent transparent ${palette.white};
    border-style: solid;
    border-width: 122px 0 0 114px;
  }
`;
